// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__0loAm","content":"style_content__I8BsM","content_title":"style_content_title__XHLFl","content_attention":"style_content_attention__ISjnr"};